export interface ConnectionBridgeState {
  isConnected: boolean;
  isConnecting: boolean;
  isMicrophoneMuted: boolean;
  isVolumeMuted: boolean;
  volume: number;
  isPortraitMode: boolean;
  isWindowsSplit: boolean;
  isAgentSpeaking: boolean;
  isAgentThinking: boolean;
  avatarImage: string;
  connectStatus: 'connected' | 'disconnected' | 'reconnecting';
}

export interface ConnectionBridge {
  getState: () => ConnectionBridgeState;
  connect: () => void;
  disconnect: () => void;
  toggleMicrophone: () => void;
  toggleVolumeMute: () => void;
  volumeChange: (value: number) => void;
  interrupt: () => void;
  summarize: () => void;
  toggleSplitWindows: () => void;
  logout: () => void;
}

declare global {
  interface Window {
    __connectionBridge?: ConnectionBridge;
  }
}

export const getConnectionBridge = (): ConnectionBridge | null => {
  try {
    return window.opener?.__connectionBridge ?? null;
  } catch {
    return null;
  }
};
